import { render, staticRenderFns } from "./Dashboardoption2.vue?vue&type=template&id=60a4d70d&"
import script from "./Dashboardoption2.vue?vue&type=script&lang=js&"
export * from "./Dashboardoption2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports